'use strict';

/** @type {import('./isNegativeZero')} */
module.exports = function isNegativeZero(x) {
	return x === 0 && 1 / x === 1 / -0;
};



//////////////////
// WEBPACK FOOTER
// ./~/math-intrinsics/isNegativeZero.js
// module id = 155
// module chunks = 231608221292675